export enum StyleTypes {
    Primary = "Primary",
    Secondary = "Secondary",
    Tertiary = "Tertiary" 
}